import type { Highlight, HighlightGeometry } from '../types';

export function highlightToGeometry(h: Highlight, pageNumber?: number): HighlightGeometry | null {
    const page = pageNumber ?? h.pageNumber;
    switch (h.type) {
        case 'text':
            return { type: 'text', page, startOffset: h.startOffset, endOffset: h.endOffset, text: h.text };
        case 'positioned':
            return { type: 'positioned', page, x: h.x, y: h.y };
        case 'polygon':
            return { type: 'polygon', page, points: h.points };
        case 'rect':
            return { type: 'rect', page, x1: h.x1, y1: h.y1, x2: h.x2, y2: h.y2 };
        default:
            return null;
    }
}
